import type { AccountSummary as GQLItem } from '../../../generated/internal.graphql';
import { take } from '../../../util';

/**
 * The account an internal (cross-account) record belongs to. Top-level under `Internal/` rather
 * than nested in `Order/` because `AccountSummary` is a schema-wide type the staff `customers`
 * query resolves too.
 */
export type Account = {
  id: number;
  name: string;
};

export const fromGql = (item: GQLItem): Account =>
  take<Account>(item, 'id', 'name');
